import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { constants } from '../../../config';
import { routeNaming, goToPage } from '../../../routes';
import { SecondaryButton } from '../../../common/secondary-button';
import { LoginHelper } from '../../../helpers/LoginHelper';
import { getDebitCartTax } from '../../../helpers/CartHelper';
import { CartStore } from '../../../stores/CartStore';
import { CHECKOUT_STAGES } from '../../../stores/CheckoutStore';
import { SessionStore } from '../../../stores/SessionStore';
import { ScreenStore } from '../../../stores/ScreenStore';
import { ConfigParametersStore } from '../../../stores/ConfigParametersStore';
import styles from './Summary.css';
import * as modalGlobal from '../../../common/global/modal';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const afterConfirm = () => {
  if (!SessionStore.loggedIn) {
    // Force the user to login
    LoginHelper.setLoginSuccessRoute(routeNaming.CART);
    goToPage(routeNaming.LOGIN);
  } else {
    goToPage(routeNaming.CHECKOUT, { checkoutStep: CHECKOUT_STAGES.CHOOSE_ADDRESS });
  }
};

const onContinueClick = () => {
  const inPresale = CartStore.cart.some(x =>
    ConfigParametersStore.isValueInFeatureFlagData('product_next_deliveries', x.product.id));

  if (inPresale) {
    modalGlobal.showModal(
      '', `<b>Aviso:</b> al menos uno de los productos que está comprando se 
      encuentra en pre-venta, por lo que su entrega no será inmediata. 
      En la página del producto podrá ver la fecha de entrega.`, true, null,
      'Aceptar', true, afterConfirm,
      'Cancelar', true, null,
    );
  } else {
    afterConfirm();
  }
};

const Summary = (props) => {
  const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
  return (
    <div className={[props.className, styles.container].join(' ')}>
      {
        !mobileVersion &&
        <h4 className={styles.title}>
          Resumen
        </h4>
      }
      <div className={styles.totalsContainer}>
        <p className={styles.subtotal}>
          Subtotal ({CartStore.cartTotalItems} producto{CartStore.cartTotalItems !== 1 && 's'})
        </p>
        <p className={styles.price}>
          ${CartStore.cart ? CartStore.cartTotalPriceWithoutDebitCardTaxString : 0}
        </p>
      </div>
      {
        !mobileVersion &&
        <div className={styles.separator} />
      }
      {/* TODO: implement this action */}
      <SecondaryButton
        className={styles.continueButton}
        disabled={
          !CartStore.cart ||
          !CartStore.cart.length ||
          !CartStore.cartStatusIsValid ||
          getDebitCartTax(CartStore.cart) != null
        }
        onClick={onContinueClick}
      >
        Continuar
      </SecondaryButton>
    </div>
  );
};

Summary.propTypes = IPropTypes;
Summary.defaultProps = defaultProps;

const ObservedSummary = observer(Summary);

export { ObservedSummary as Summary };



// WEBPACK FOOTER //
// ./src/pages/cart/summary/Summary.jsx